import { Component, OnInit } from '@angular/core';
import { ServerURLService } from 'src/app/common-service/serverURL.service';
import { PtrService } from '../ptr-service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { encryptionService } from '../../../app/common-service/cedService';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import { EncrDecrService } from 'src/app/common-service/EncrDecrService';
import { UsrmgtService } from 'src/app/usermgt/services/usrmgt.service';
import { SignupService } from 'src/app/common-service/signup.service';

@Component({
  selector: 'app-ptr-payment-receipt',
  templateUrl: './ptr-payment-receipt.component.html',
  styleUrls: ['./ptr-payment-receipt.component.css']
})
export class PtrPaymentReceiptComponent implements OnInit {
  submitted = false;
  userDetails: any;
  registrationId: any;
  decryptRegistrationId: any;
  roleName: any;
  totalAmount: any;
  totalAmountGST: any;

  constructor(public tostar: ToastrService, public router: Router, public route: ActivatedRoute,
    public helper: HelperService, public signin: PtrService, private spinner: NgxSpinnerService, public ced: encryptionService, private toastr: ToastrService, public serverURL: ServerURLService,
    public usrMgtService: UsrmgtService,
    public EncrDecr: EncrDecrService, public signinService: SignupService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => this.decryptRegistrationId = params.id);
    this.registrationId = this.EncrDecr.get(this.serverURL.secretKey, this.decryptRegistrationId);
    this.roleName = sessionStorage.getItem('selectedRole-usec');

    if (this.roleName === 'PTR' || this.roleName === 'College Principal') {
      this.getPtrDetails();
    } else {
      this.signinService.deleteOauthToken();
    }
  }

  getPtrDetails() {
    this.route.params.subscribe(params => {
      if (this.registrationId != undefined) {
        this.spinner.show();
        this.signin.userDetailsById(this.registrationId).subscribe((result: any) => {
          this.spinner.hide();
          this.userDetails = result;

          if(this.userDetails?.inviteeList?.length > 0) {

            this.userDetails?.inviteeList?.length * 3000;
            this.totalAmount = this.userDetails?.inviteeList?.length * 3000;
            this.totalAmountGST = this.totalAmount + ((this.totalAmount * 18) / 100);
          }
        }, error => {
          this.spinner.hide();
          console.log(error);
          this.helper.errorMessage(error);
        });
      }
    });
  }

  onSubmit() {
    this.signin.updatePaymentDetails(this.userDetails).subscribe((data: any) => {
      if (data.response.respcode == '200') {
        var anchor = document.createElement('a');
        anchor.href = data.encyPaymentReqUrl;
        anchor.click();
      } else if (data.response.respcode == '500') {
        this.spinner.hide();
        this.displayErrorMsg('error', data.response.message);
      } else {
        this.spinner.hide();
        this.displayErrorMsg('error', 'Update is Failed!!');
      }
    }, error => {
      this.spinner.hide();
      error.status = error.status == 0 ? 500 : error.status
    });
  }

  private displayErrorMsg(type: string, msg: string) {
    if (type == 'error') {
      this.toastr.error(msg, 'Error', {
        timeOut: 3000
      });
    }
  }

  back() {
    this.router.navigate(['/main/internal/ptr/dashboard/0']);
    sessionStorage.setItem("back", "back");
  }
}
